/**
 * Navigation icons are now inline SVG components: see src/components/kid/KidIcon.tsx
 * (kid-first redesign, 2026-10-11). The old illustrated PNGs in public/nav/ were removed; they
 * remain in git history.
 */

/** Theme toggle artwork in Settings (`public/theme/`). */
export const THEME_ICON_PATHS = {
  light: '/theme/light-mode.png',
  dark: '/theme/dark-mode.png',
} as const;
